module.exports = __webpack_public_path__ + "media/theme/icon__visa-fc8f1d28.png";